import { __decorate } from "tslib";
import { AnyDecoder, ArrayDecoder, AutoEncoder, DateDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from "uuid";
import { MemberDetails } from './MemberDetails';
export class Member extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * @deprecated Marked for removal
         * Slowly migrate towards a non-encrypted member in the future
         */
        this._f = "";
        /**
         * @deprecated Marked for removal
         * Slowly migrate towards a non-encrypted member in the future
         */
        this._ed = [];
        this.outstandingBalance = 0;
        this.createdAt = new Date();
        this.updatedAt = new Date();
    }
    get isMinor() {
        return (this.details.age !== null && this.details.age < 18);
    }
    get firstName() {
        return this.details.firstName;
    }
    get name() {
        return this.details.name;
    }
    static sorterByName(sortDirection = "ASC") {
        return (a, b) => {
            if (!a.details && !b.details) {
                return 0;
            }
            if (!a.details) {
                return 1;
            }
            if (!b.details) {
                return -1;
            }
            if (sortDirection == "ASC") {
                if (a.details.name.toLowerCase() > b.details.name.toLowerCase()) {
                    return 1;
                }
                if (a.details.name.toLowerCase() < b.details.name.toLowerCase()) {
                    return -1;
                }
                return 0;
            }
            if (a.details.name.toLowerCase() > b.details.name.toLowerCase()) {
                return -1;
            }
            if (a.details.name.toLowerCase() < b.details.name.toLowerCase()) {
                return 1;
            }
            return 0;
        };
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Member.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true, field: 'firstName' }),
    field({ decoder: StringDecoder, optional: true, version: 165 })
], Member.prototype, "_f", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(AnyDecoder), optional: true, field: 'encryptedDetails' }),
    field({ decoder: new ArrayDecoder(AnyDecoder), optional: true, version: 165 })
], Member.prototype, "_ed", void 0);
__decorate([
    field({ decoder: MemberDetails, field: 'nonEncryptedDetails' }),
    field({ decoder: MemberDetails, version: 165 })
], Member.prototype, "details", void 0);
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], Member.prototype, "outstandingBalance", void 0);
__decorate([
    field({ decoder: DateDecoder, version: 31 })
], Member.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder, version: 31 })
], Member.prototype, "updatedAt", void 0);
//# sourceMappingURL=Member.js.map